import { render, staticRenderFns } from "./MyHeader5.vue?vue&type=template&id=56a0fe11&scoped=true"
import script from "./MyHeader5.vue?vue&type=script&lang=js"
export * from "./MyHeader5.vue?vue&type=script&lang=js"
import style0 from "./MyHeader5.vue?vue&type=style&index=0&id=56a0fe11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0fe11",
  null
  
)

export default component.exports